import avito from '../../../../../assets/media/icons/avito1.png';
import Row from '../../../../../components/Basic/Blocks/Row';
import Button from '../../../../../components/Basic/Buttons/Button';
import Icon from '../../../../../components/Basic/Elements/Icon';
import { TYPE_BUTTONS } from '../../../../../constans';


const AvitoContentButton = ({ roleUser = 'content', onClick = (_) => _ }) => {
  return (
    <Row style={{ alignItems: 'flex-end' }}>
      <Button type={TYPE_BUTTONS.WHITE} onClick={() => onClick()}>
        <Icon src={avito} width={'25px'} style={{ marginRight: '10px' }} />
        Перенести в авито
      </Button>
    </Row>
  );
};
export default AvitoContentButton;
